// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pj_a bhi_ea bhi_kb bhi_js bhi_a bhi_j bhi_sm bhi_sn","SearchPanel__icon":"pj_b bhi_vm bhi_hg bhi_ss bhi_uy","SearchPanel__input":"pj_c bhi_iz bhi_eb bhi_z"};